import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { QueryBasicComponent } from './query-basic/query-basic.component';
import { QueryBuildModule } from '../query-build';

import { QueryBuilderOutputComponent } from './query-builder-output/query-builder-output.component';
import { HighlightModule } from 'ngx-highlightjs';
import { QueryResultsComponent } from './query-results/query-results.component';
import { CsvChipLoaderComponent } from './csv-chip-loader/csv-chip-loader.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SelectButtonModule } from 'primeng/selectbutton';


@NgModule({
  declarations: [
    QueryBasicComponent,
    QueryBuilderOutputComponent,
    QueryResultsComponent,
    CsvChipLoaderComponent,
  ],
  imports: [SharedModule, QueryBuildModule, HighlightModule, ConfirmDialogModule, SelectButtonModule],
})
export class QueryBasicModule {}
